import React from 'react'
import { withStyles } from '@mui/styles'

import lang from 'lang'
import config from '@/config'
import { TextInput, ZipCodeInput, CountryInput } from '@/modules/base/components/inputs'

const BaseFormFields = (props) => {
  const {
    data = {},
    onChange,
    classes,
    useFormik,
    readOnly,
  } = props

  const { street, zipCode, city, countryIso } = data

  const handleTextInputChange = (value, name) => {
    onChange && onChange({ [name]: value })
  }

  const handleZipCodeChange = ({ city, zipCode }) => {
    onChange && onChange({ city, zipCode })
  }

  const handleCountryChange = (option) => {
    const countryIso = option ? option.iso2 : ''
    onChange && onChange({ countryIso })
  }

  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        <div className='col-xs-12 col-sm-6'>
          <TextInput
            dataQsId='baseFormFields-street'
            name='street'
            label={lang.streetFieldLabel}
            value={street}
            onChange={handleTextInputChange}
            readOnly={readOnly}
            useFormik={useFormik} />
        </div>
        <div className={`${classes.row} ${classes.zipCodeAndCity} col-xs-12 col-sm-6`}>
          <ZipCodeInput dataQsId='baseFormFields-zipCodeCity' readOnly={readOnly} zipCode={zipCode} city={city} onChange={handleZipCodeChange} useFormik={useFormik} />
        </div>
      </div>
      <div className={classes.row}>
        <div className='col-xs-12 col-sm-6'>
          <CountryInput dataQsId='baseFormFields-country' menuPlacement='top' maxMenuHeight={260} readOnly={readOnly} value={countryIso || config.defaultCountryAsISO2} onChange={handleCountryChange} includeCodeInLabel useFormik={useFormik} />
        </div>
      </div>
    </div>
  )
}

const styles = (theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      gap: 20,
    },
  },
  row: {
    display: 'flex',
    flex: '0 1 auto',
    flexDirection: 'row',
    flexWrap: 'wrap',
    margin: '0rem -0.5rem 25px -0.5rem',

    '& > div:first-of-type': {
      paddingRight: 25,
      [theme.breakpoints.down('md')]: {
        paddingRight: 0,
        paddingLeft: 0,
      },
    },
    '& > div:last-of-type': {
      paddingLeft: 25,
      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
      },
    },
    '& > div:first-of-type:last-of-type': {
      paddingLeft: 7,
      [theme.breakpoints.down('md')]: {
        paddingLeft: 0,
      },
    },
    [theme.breakpoints.down('md')]: {
      margin: 0,
      gap: 20,
    },
  },
  zipCodeAndCity: {
    paddingRight: 0,
    marginBottom: 0,

    '& > div:first-of-type': {
      paddingRight: 7,
    },
    '& > div:last-of-type': {
      paddingRight: 0,
      paddingLeft: 7,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
})

export default withStyles(styles)(BaseFormFields)
